import BaseController from "confinus_ui/base_controller";

export default class extends BaseController {
  static targets = ["form"];

  declare readonly formTarget: HTMLFormElement;

  dateChanged(event: CustomEvent): void {
    const selectedDate = event.detail.selectedDate;

    if (!selectedDate) return;

    // Submit the form via Turbo to navigate to the new date
    this.formTarget.requestSubmit();
  }
}
